import { Navigate, Route, Routes } from "react-router-dom";

import styled from "styled-components";

import LabPublicPage from "../pages/lab-public-page";
import RecoveryPage from "../pages/recover-page";
import StudentProfileIntoPage from "../pages/student-profile-info-page";
import WrappedStudentProfileIntoPage from "../pages/wrapped-student-profile-info-page";
import StudentAmbassadorIntoPage from "../pages/student-ambassador-info-page";

import BookingsListPage from "components/pages/bookings-list-page";
import CreateBookingPage from "components/pages/create-booking-page";
import CreateEventBookingPage from "components/pages/create-event-booking-page";
import DormitoryPublicPage from "components/pages/dormitory-public-page";
import EventsPublicPage from "components/pages/events-public-page";
import EventsSearchPage from "components/pages/events-search-page";
import LabsSearchPage from "components/pages/labs-search-page";
import NotificationsPage from "components/pages/notifications-page";
import SearchResultsPage from "components/pages/search-results-page";
import UniversityPublicPage from "components/pages/university-public-page";
import Header from "components/tools/header";
import { Frame } from "components/ui-kit/styled-templates";
import AmbassadorsListPage from "../pages/ambassadors-list-page";
import AmbassadorPage from "../pages/ambassador-page";
import NewsListPage from "../pages/news-list-page";
import AboutProgramPage2 from "../pages/about-program-page2";
import UniversiesPage from "../pages/universities-page";
import ClubsPage from "../pages/clubs-page";
import ScienceSelectPage from "../pages/science-select-page";
import ScienceLabsPage from "../pages/science-labs-page";
import ScienceProgramPage from "../pages/science-products-page";
import InternationalPage from "../pages/international-page";
import PatriotPage from "../pages/patriot-page";
import IndustrialPage from "../pages/industrial-page";
import NewsArticlePage from "../pages/news-article-page";
import PartnersPage from "../pages/partners-page";
import ClubPublicPage from "../pages/club-public-page";
import ContactsPage from "../pages/contacts-page";
import FaqPage from "../pages/faq-page";
import IntensivePage from "../pages/intensive-page";
import MainLandingPage from "../pages/main-landing-page";

const StudentApp = () => {
    return (
        <>
            <Wrapper className={'student_app'} >
                <Header />
                <Routes>

                    <Route path="/" element={<MainLandingPage />} />

                    <Route path="/international" element={<InternationalPage />} />
                    <Route path="/patriot" element={<PatriotPage />} />
                    <Route path="/partners" element={<PartnersPage />} />

                    <Route path="/contacts" element={<ContactsPage />} />
                    <Route path="/faq" element={<FaqPage />} />
                    <Route path="/intensive" element={<IntensivePage />} />

                    <Route path="/industrial" element={<IndustrialPage />} />
                    <Route path="/universities" element={<UniversiesPage />} />
                    <Route path="/clubs" element={<ClubsPage />} />
                    <Route path="/club/:clubId" element={<ClubPublicPage/>} />
                    <Route path="/science" element={<ScienceSelectPage />} />
                    <Route path="/science-labs" element={<ScienceLabsPage />} />
                    <Route path="/science-products" element={<ScienceProgramPage />} />
                    <Route path="/news" element={<NewsListPage />} />
                    <Route path="/news/:newsId" element={<NewsArticlePage />} />
                    <Route path="/recover/:recoveryKey" element={<RecoveryPage />} />
                    <Route path="/about-program" element={<AboutProgramPage2 />} />
                    <Route path="/profile" element={<WrappedStudentProfileIntoPage />} />
                    <Route path="/ambassador-profile" element={<StudentAmbassadorIntoPage />} />
                    <Route path="/search" element={<SearchResultsPage />} />
                    <Route path="/dormitory/:dormitoryId" element={<DormitoryPublicPage />} />
                    <Route path="/labs-search" element={<LabsSearchPage />} />
                    <Route path="/ambassadors" element={<AmbassadorsListPage />} />
                    <Route path="/lab/:labId" element={<LabPublicPage />} />
                    <Route path="/ambassadors/:ambassadorId" element={<AmbassadorPage />} />
                    <Route path="/ambassadors/:ambassadorId/posts/:postId" element={<AmbassadorPage />} />
                    <Route path="/bookings" element={<BookingsListPage />} />
                    <Route path="/create-booking/:dormitoryId" element={<CreateBookingPage mode="create" />} />
                    <Route path="/edit-booking/:bookingId" element={<CreateBookingPage mode="edit" />} />
                    <Route path="/events/:eventId" element={<EventsPublicPage />} />
                    <Route path="/create-event-booking/:eventId" element={<CreateEventBookingPage mode="create" />} />
                    <Route path="/edit-event-booking/:requestId" element={<CreateEventBookingPage mode="edit" />} />
                    <Route path="/events-search" element={<EventsSearchPage />} />
                    <Route path="/university/:universityId" element={<UniversityPublicPage />} />
                    <Route path="/notifications" element={<NotificationsPage />} />
                    {/*<Route path="/*" element={<Navigate to="search" />} />*/}
                    <Route path="/*" element={<Navigate to={`/`} />} />
                </Routes>
            </Wrapper>
        </>
    );
};

export const Wrapper = styled(Frame).attrs((props) => {
    return { ...props, id: "scrollWrapper" };
})`
  width: 100%;
  flex: 1;
  min-height: 100vh;
  justify-content: flex-start;
  /* padding: 35px 0; */
  box-sizing: border-box;
  flex: 1;
  display: flex;
  overflow: auto;
  max-height: 100vh;
  overflow-x: hidden;
`;

export default StudentApp;
